module.exports = __webpack_public_path__ + "@/assets/img/code.2f6992fb.svg";